module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit class","weaponsActionsEditOneSuccess":"%{weaponsName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger klasse","weaponsActionsEditOneSuccess":"%{weaponsName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
